import React from "react";
import "./MovingTicker.css";

const MovingTicker = ({ children }) => {
  return (
    <div className="mt-banner">
      <div className="mt-track">
        <span className="mt-text">{children}</span>
        <span className="mt-text">{children}</span>
      </div>
    </div>
  );
};

export default MovingTicker;
